export default "__VITE_ASSET__DYBbH2v3__"